import React from "react";
import { CTAButton } from "./UI";

const FEATURES = [
  {
    n: "01",
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M12 2L2 7l10 5 10-5-10-5z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
        <path d="M2 17l10 5 10-5" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
        <path d="M2 12l10 5 10-5" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
      </svg>
    ),
    title: "Designed for your brand",
    body: "Every pixel is built around your identity — not a generic template.",
  },
  {
    n: "02",
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    title: "Built to convert",
    body: "Clear structure, fast load, strong calls to action. Your site works while you sleep.",
  },
  {
    n: "03",
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="2" y="4" width="20" height="14" rx="2" stroke="currentColor" strokeWidth="1.5"/>
        <path d="M8 20h8M12 18v2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
        <path d="M2 8h20" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round"/>
        <circle cx="5" cy="6" r="0.8" fill="currentColor"/>
        <circle cx="8" cy="6" r="0.8" fill="currentColor"/>
      </svg>
    ),
    title: "Works on every device",
    body: "Fully responsive design that looks sharp on mobile, tablet and desktop.",
  },
];

const TYPES = ["Business Website", "Landing Page", "E-commerce Store", "Digital Experience"];

export default function WebsiteSection() {
  return (
    <section id="digital" className="section section-border">
      <div className="container">

        <div className="ws-top">
          <div className="ws-top-left">
            <span className="eyebrow">Digital · Web</span>
            <h2 className="h2" style={{ marginTop: 16 }}>
              Your website is your best salesperson. Is it doing its job?
            </h2>
          </div>
          <div className="ws-top-right">
            <p className="lede">
              We design and develop websites and online stores that look like your brand, load fast and are built to turn visitors into paying customers.
            </p>
            <div className="ws-types">
              {TYPES.map((t) => (
                <span className="ws-type-chip" key={t}>{t}</span>
              ))}
            </div>
          </div>
        </div>

        {/* Visual break — website/device mockup image */}
        <div className="ws-img-wrap">
          <img
            src="https://images.unsplash.com/photo-1467232004584-a241de8bcf5d?w=1400&q=80"
            alt="Web design and development — clean digital workspace"
            className="ws-img"
            loading="lazy"
          />
          <div className="ws-img-caption">
            <span>Designed to convert. Built to perform.</span>
          </div>
        </div>

        <div className="ws-features">
          {FEATURES.map((f) => (
            <div className="ws-feature" key={f.n} data-n={f.n}>
              <span className="ws-feature-icon">{f.icon}</span>
              <span className="num">{f.n}</span>
              <h3 className="ws-feature-title">{f.title}</h3>
              <p className="ws-feature-body">{f.body}</p>
            </div>
          ))}
        </div>

        <div style={{ marginTop: 56 }}>
          <CTAButton href="#contact">Build your website</CTAButton>
        </div>

      </div>
    </section>
  );
}
